<!-- 展商报名 -->
<template>
  <div class="i-interactor-wrap-en">
    <div class="interactor-title" v-show="userList.length > 0">{{$t('organizer')}}</div>
    <inter-actor-card v-for="item in userList" :key="item.id" :item="item" :languageType="languageType">
    </inter-actor-card>
    <div class="interactor-title" v-show="formFieldList.length > 0">{{$t('fill_in_registration_information')}}</div>
    <div class="interactor-info-view">
      <van-form>
        <van-cell-group>
          <van-field v-for="item in formFieldList" :key="item.id" :required="item.required"
            :placeholder="item.placeholder" :label="item.name" :value="getLabelByKey(item)"
            :maxlength="item.inputLength" :right-icon="item.canSelect ? 'arrow' : '' " :readonly="item.canSelect"
            :disabled="getDisabledStatus(item)" @input="inputChange" @click="clickSelect(item.keyword)">
          </van-field>
        </van-cell-group>
      </van-form>
      <ibutton class="interactor-submit-btn" :text="$t('submit')" @clickBtn="submit"></ibutton>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker title="" :value-key="valueKey" show-toolbar :columns="columns" :cancel-button-text="$t('cancel')" :confirm-button-text="$t('confirm')" @confirm="onConfirm" @cancel="onCancel"
        @change="onChange" />
    </van-popup>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import interActorCard from '@/components/interActor/interActor-card.vue'
import ibutton from '@/components/i-button/i-button.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    interActorCard,
    ibutton
  },
  data () {
    // 这里存放数据
    return {
      dataSource: {},     // 数据源
      labelDic: {},       // 展示字典
      countKey: '',       // 当前Key -- 用于配置项为选择项时记录当前操作项
      countryDic: '',     // 当前国家
      countryList: [],    // 国家数组
      provinceDic: '',    // 当前省份
      provinceList: [],   // 省份数组
      cityDic: '',        // 当前城市
      cityList: [],       // 城市数组
      valueKey: '',
      formFieldList: [],
      languageType: "",
      userList: [],       // 人员列表
      columns: [],
      showPicker: false,
      value1: '',
      value: ''
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    var queryToken = this.$route.query.Token ? this.$route.query.Token : this.$route.query.token;
    var token = this.$tools.decodeToken(queryToken);
    if (token) {
      this.$store.commit('changeToken', token);
    }
    this.languageType = this.$route.query.languageType || 'cn';
    this.$i18n.locale = this.languageType;
    this.applicationId = this.$route.query.applicationId;
    this.$http.subjectTypeByToken(token).then(res => {
      console.log(res.data);
      if (res.data == 'VISITOR') {
        this.$router.replace({
          name: 'interVisitor',
          query: {
            token: token,
            exhibitionId: this.$route.query.exhibitionId ? this.$route.query.exhibitionId : 'bd675efab4bf49c2996adbd7322565b0' ,
            languageType: this.$route.query.languageType
          }
        });
        return;
      }
      // 展商端
      this.getData();
    }).catch(error => {
      this.$Toast(error.data.message);
    })
    

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    window.document.title = this.$t('exhibitor_registration');
    let yclientHeight = document.documentElement.clientHeight //原来的可视高度
    window.onresize = () => {
      let bclientHeight = document.documentElement.clientHeight //变化后的可视高度
      let scrollHeight = yclientHeight - bclientHeight//虚拟键盘的高度
      document.querySelector('.add-contact-box').style.top = -scrollHeight + 'px'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    init(token) {
      
    },
    submit () {
      console.log(this.dataSource);
      if (!this.checkParams()) {
        return;
      }
      this.$Toast.loading({
        message: '',
        forbidClick: true,
      });
      this.dataSource['exhibitionId'] = this.$route.query.exhibitionId;
      this.$http.exhibitorInsert(this.dataSource).then(res => {
        // 保存成功
        this.dataSource['id'] = 1;
        this.$Toast(this.$t('please_contact_the_organizer'));
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 校验参数
    checkParams () {
      if (this.dataSource['id']) {
        this.$Toast(this.$t('cannot_be_modified'))
        return false;
      }
      for (let i = 0; i < this.formFieldList.length; i++) {
        var d = this.formFieldList[i];
        var toast = this.$t('information_please_fill_in');
        if (d.canSelect) {
          toast = this.$t('information_please_choose');
        }
        if (d.required && !this.dataSource[d.keyword]) {
          this.$Toast(toast + d.name);
          return false;
        }
        if (d.required && d.keyword == 'contactEmail' && !this.$tools.checkReg(this.dataSource[d.keyword], 1)) {
          this.$Toast(this.$t('incorrect_email'));
          return false;
        }
        if (d.required && d.keyword == 'contactMobile' && !this.$tools.checkReg(this.dataSource[d.keyword], 2)) {
          this.$Toast(this.$t('incorrect_phone_number'));
          return false;
        }
      }
      return true;
    },
    getDisabledStatus (item) {
      if (item.keyword == 'exhibitorReserveExhibitionId') {
        return false;
      }
      if (item.keyword == 'country' && !this.dataSource['id']) {  // 国家
        return false;
      }
      if (item.keyword == 'province' && !this.dataSource['id']) { // 省份
        return false;
      }
      if (item.keyword == 'city' && !this.dataSource['id']) {     // 城市
        return false;
      }
      if (item.canSelect || this.dataSource['id']) {
        return true;
      }
      return false;
    },
    getLabelByKey (item) {
      if (item.keyword == 'exhibitorReserveExhibitionId') { // 展商ID
        return this.dataSource['exhibitorReserveExhibitionIdName'];
      }
      if (item.keyword == 'country') {  // 国家
        return this.dataSource['countryTitle'];
      }
      if (item.keyword == 'province') { // 省份
        return this.dataSource['provinceTitle'];
      }
      if (item.keyword == 'city') { // 省份
        return this.dataSource['cityTitle'];
      }
      return this.dataSource[item.keyword];
    },
    clickSelect (key) {
      this.countKey = key;
      if (key == "exhibitorReserveExhibitionId") {  // 展会名称选择
        this.showPicker = true;
        this.valueKey = 'name';
        this.getExhibitionInfo();
      }
      if (key == "country" && !this.dataSource['id']) {       // 国家选择
        this.showPicker = true;
        this.valueKey = 'name';
        this.getCountryInfo();
      }
      if (key == "province" && !this.dataSource['id']) {      // 省份选择
        this.valueKey = 'name';
        this.getProvinceInfo();
      }
      if (key == "city" && !this.dataSource['id']) {          // 城市选择
        this.valueKey = 'name';
        this.getCityInfo();
      }
    },
    // 输入框值发生变化
    inputChange (value) {
      this.dataSource[this.countKey] = value;
    },
    onConfirm (value, index) {
      console.log(value)
      if (this.countKey == "exhibitorReserveExhibitionId") {    // 展会名称选择
        this.getExhibitorReserveExhibition(value);
      }
      if (this.countKey == "country") {         // 国家选择
        this.countryDic = value;
        this.dataSource["country"] = value.id;
        this.dataSource["countryTitle"] = value.name;

        this.provinceDic = "";
        this.dataSource["province"] = "";
        this.dataSource["provinceTitle"] = "";

        this.cityDic = "";
        this.dataSource["city"] = "";
        this.dataSource["cityTitle"] = "";
      }
      if (this.countKey == "province") {        // 省份选择
        this.provinceDic = value;
        this.dataSource["province"] = value.id;
        this.dataSource["provinceTitle"] = value.name;

        this.cityDic = "";
        this.dataSource["city"] = "";
        this.dataSource["cityTitle"] = "";
      }
      if (this.countKey == "city") {            // 城市选择
        this.cityDic = value;
        this.dataSource["city"] = value.id;
        this.dataSource["cityTitle"] = value.name;
      }
      this.showPicker = false;
    },
    onCancel (picker, value, index) {
      this.showPicker = false;
    },
    onChange () { },
    getData () {
      this.getUserList();
      this.getConfig();
    },
    // 获取人员列表
    getUserList () {
      var exhibitionId = this.$route.query.exhibitionId;
      this.languageType = this.$route.query.languageType;
      var params = {
        "exhibitionId": exhibitionId,
        "languageType": this.languageType
      }
      this.$http.getOrganizerLinkList(params).then(res => {
        var data = res.data;
        this.userList = data;
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    // 获取配置项
    getConfig () {
      var params = {
        languageType: this.languageType,
        subjectType: "EXHIBITORREGISTER"
      }
      this.$http.getConfigurationInformation(params).then(res => {
        var data = res.data;
        this.formFieldList = data.formFieldList
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 获取展会列表
    getExhibitionInfo () {
      var exhibitionId = this.$route.query.exhibitionId;
      var params = {
        exhibitionId: exhibitionId,
        languageType: this.languageType,
      }
      this.$http.getExhibitionList(params).then(res => {
        var data = res.data;
        this.columns = data;
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 获取国家
    getCountryInfo () {
      if (this.countryList.length > 0) {
        this.columns = this.countryList;
        return;
      }
      var params = {
        languageType: this.languageType
      }
      this.$http.getCountryList(params).then(res => {
        // countryId
        var data = res.data;
        this.columns = data;
        this.countryList = data;
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 获取省份
    getProvinceInfo () {
      if (this.countryDic.length == 0) {
        // 请选择国家
        this.$Toast(this.$t('information_please_choose') + this.$t('country'));
        return;
      }
      this.showPicker = true;
      var params = {
        languageType: this.languageType,
        countryId: this.countryDic.id
      }
      this.$http.getProvinceList(params).then(res => {
        // countryId
        var data = res.data;
        this.columns = data;
        this.provinceList = data
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 获取城市
    getCityInfo () {
      console.log(this.formFieldList)
      if (this.provinceDic.length == 0) {
        // 请选择省份
        this.$Toast(this.$t('information_please_choose') + this.$t('province'));
        return;
      }
      this.showPicker = true;
      var params = {
        languageType: this.languageType,
        provinceId: this.provinceDic.id
      }
      this.$http.getCityList(params).then(res => {
        // countryId
        var data = res.data;
        this.columns = data;
        this.cityList = data
      }).catch(error => {
        this.$Toast(error.data.message);
      })
    },
    // 查询预约报名展会信息 id:预约报名展会ID
    getExhibitorReserveExhibition (value) {
      var params = {
        exhibitorReserveExhibitionId: value.id,
        languageType: this.languageType
      }
      this.$http.exhibitorReserveExhibition(params).then(res => {
        var data = res.data;
        this.dataSource = data;
        this.dataSource['exhibitorReserveExhibitionIdName'] = value.name;
        this.dataSource['exhibitorReserveExhibitionId'] = value.id;
        this.$set(this.formFieldList, this.formFieldList[0], this.formFieldList[0]);// 触发页面刷新

      }).catch(error => {
        this.$Toast(error.data.message);
      })
    }
  }

}
</script>
<style scoped>
.interactor-title {
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 150;
  color: rgba(66, 66, 66, 1);
  line-height: 20px;
  margin: 12px 0px 0px 15px;
}
.interactor-info-view {
  padding: 0px 15px;
  margin-top: 12px;
  background-color: #ffffff;
}
.van-cell__right-icon {
  line-height: 24px !important;
}
.interactor-submit-btn {
  margin-top: 44px;
  padding-bottom: 48px;
}
.van-field__value{
  padding:0 15px;
}
</style>
